module.exports = __webpack_public_path__ + "static/media/add-logo-mobile-es.133a3575.png";